import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AddressModule } from "./address/address.module";
import { OrderModule } from "./order/order.module";
import { FeatureToggleModule } from "./feature-toggle/feature-toggle.module";

@NgModule({
  imports: [CommonModule, AddressModule],
  exports: [AddressModule, OrderModule, FeatureToggleModule]})
export class CoreModule {}
